export const parseFileToDataUrl = (file: File) => {
  const fileBlob = !!file && new Blob([file], { type: file.type });
  return fileBlob ? URL.createObjectURL(fileBlob) : "";
};
